import './index.css'

const NavBar = props => {
  const {score, timer} = props

  return (
    <div className="nav-bar">
      <img
        src="https://assets.ccbp.in/frontend/react-js/match-game-website-logo.png"
        className="website-logo"
        alt="website logo"
      />
      <div className="x">
        <div className="score-card">
          <p className="score-text">Score:</p>
          <p className="score-valuex">{score}</p>
        </div>

        <div className="timer-card">
          <img
            src="https://assets.ccbp.in/frontend/react-js/match-game-timer-img.png "
            alt="timer"
            className="timer"
          />
          <p className="timer-countdown"> {timer} sec</p>
        </div>
      </div>
    </div>
  )
}

export default NavBar
